<template>
  <auth-shell>
    <p class="auth-form__eyebrow">
      Tu cuenta
    </p>
    <h1 class="auth-form__title auth-form__title--with-lead">
      Confirmar nuevo correo
    </h1>
    <p class="auth-form__lead">
      {{ description }}
    </p>

    <div
      v-if="loading"
      class="auth-status auth-status--loading"
    >
      <b-spinner small />
      <span>Estamos validando tu enlace...</span>
    </div>

    <div
      v-else
      :class="['auth-status', success ? 'auth-status--success' : 'auth-status--error']"
      role="status"
    >
      <feather-icon
        :icon="success ? 'CheckCircleIcon' : 'AlertTriangleIcon'"
        size="18"
      />
      <span>{{ message }}</span>
    </div>

    <b-button
      v-if="!loading"
      class="auth-submit"
      block
      @click="goNext"
    >
      <span>{{ success ? nextLabel : 'Ir al inicio de sesión' }}</span>
      <feather-icon
        icon="ArrowRightIcon"
        size="18"
      />
    </b-button>
  </auth-shell>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { BButton, BSpinner } from 'bootstrap-vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import AuthShell from '@/components/auth/AuthShell.vue'

export default {
  components: {
    AuthShell,
    BButton,
    BSpinner,
  },
  data() {
    return {
      loading: true,
      success: false,
      message: '',
      description: 'Vamos a confirmar el nuevo correo asociado a tu cuenta.',
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    nextLabel() {
      return this.currentUser?.id ? 'Volver a la app' : 'Ir al inicio de sesión'
    },
  },
  created() {
    this.runConfirmation()
  },
  methods: {
    ...mapActions('auth', ['confirmEmailChange']),
    ...mapMutations('auth', {
      setCurrentUser: 'setCurrentUser',
    }),
    runConfirmation() {
      this.confirmEmailChange(this.$route.params.token)
        .then(response => {
          this.success = true
          this.message = 'Tu nuevo correo quedó confirmado y ya se actualizó en tu cuenta.'
          if (this.currentUser?.id === response.id) {
            this.setCurrentUser(response)
            localStorage.setItem('userData', JSON.stringify(response))
          }
        })
        .catch(error => {
          const messages = error?.messages || error?.response?.data?.messages || ['El enlace no es válido o ya expiró']
          this.success = false
          this.message = Array.isArray(messages) ? messages.join(', ') : messages
        })
        .finally(() => {
          this.loading = false
        })
    },
    goNext() {
      if (this.success && this.currentUser?.id) {
        this.$router.replace(getHomeRouteForLoggedInUser(this.currentUser))
        return
      }

      this.$router.replace({ name: 'auth-login' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../components/auth/auth-page.scss';
</style>
